import { render, staticRenderFns } from "./header-translations.vue?vue&type=template&id=00ec252a"
import script from "./header-translations.vue?vue&type=script&lang=js"
export * from "./header-translations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports